export const styles = {
  table: {
    mt: 2,
    td: { border: 'none' },
  },

  label: {
    fontWeight: 700,
  },
};
